/**
 * withTenants
 * HOC for wrapping the provided component with TenantsProvider
 */

import React from 'react'

import TenantsProvider from './tenants-provider'

export default function withTenants (WrappedComponent) {
  return function TenantsProviderHOC(props) {
    return (
      <TenantsProvider>
        <WrappedComponent {...props} />
      </TenantsProvider>
    )
  }
}
